import React, { useState, useRef, useEffect } from 'react';
import EmojiPicker, { EmojiClickData, Theme } from 'emoji-picker-react';
import UnfillEmoji from "@/assets/icons/unfillEmoji.png";

interface EmojiPickerTriggerProps {
  onEmojiSelect: (emoji: string) => void;
  className?: string; // Optional for styling the button
  pickerContainerClassName?: string; // Optional for styling the picker container
}

const EmojiPickerTrigger: React.FC<EmojiPickerTriggerProps> = ({
  onEmojiSelect,
  className,
  pickerContainerClassName,
}) => {
  const [showPicker, setShowPicker] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const pickerRef = useRef<HTMLDivElement>(null);

  // Close picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setShowPicker(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleEmojiClick = (emojiObject: EmojiClickData) => {
    onEmojiSelect(emojiObject.emoji);
    setShowPicker(false); // Close the picker after selecting an emoji
  };

  return (
    <div className={`relative inline-block ${className ? className : ''}`}>
      <button
        type="button"
        ref={buttonRef}
        onClick={() => setShowPicker((prev) => !prev)}
        className=""
        aria-label="Open emoji picker"
      >
        <img className='w-[20px]' src={UnfillEmoji} alt='UnfillEmoji' />
      </button>

      {showPicker && (
        <div ref={pickerRef} className={`absolute left-full top-0 ml-2 z-10 ${pickerContainerClassName ? pickerContainerClassName : ''}`}>
          <EmojiPicker
            onEmojiClick={handleEmojiClick}
            autoFocusSearch={false}
            theme={Theme.AUTO}
            // You can further customize the picker's appearance here if needed
          />
        </div>
      )}
    </div>
  );
};

export default EmojiPickerTrigger;